module.exports = __webpack_public_path__ + "230be686477bbabfd124f94dd7e49de7.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/disney_2020_chart.png
// module id = 1657
// module chunks = 0